module.exports = __webpack_public_path__ + "static/img/gift-14.7c043f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-14.png
// module id = 358
// module chunks = 140